export enum AvailabilityStatus {
  RUNNING = 'running',
  NOT_READY = 'not_ready',
  STARTING = 'starting',
  STOPPING = 'stopping',
  STOPPED = 'stopped'
}
